
/*##################### Mega Menu ############################*/

!(function (e) {
  "use strict";
  var i = e(window),
    a = e(document);

  e(function () {
    e(".navigation-menu > ul > li:has( > div)").addClass("menu-dropdown-icon"),
      e(".navigation-menu > ul > li.menu-dropdown-icon").append(
        '<div class="dropworn-arrow"></div>'
      ),
      e(".navigation-menu > ul > li > div:not(:has(ul))").addClass(
        "normal-sub"
      ),
      e(".navigation-menu > ul").before(
        '<a href="#" class="menu-mobile">Menu</a>'
      );
    var a = e(".navigation-menu > ul > li"),
      t = e(".menu-mobile");
    a.on("mouseenter mouseleave", function (a) {
      i.width() > parseInt(979) &&
        (e(this).children(".js-nav-dropdown").stop(!0, !1).fadeToggle(150),
        e(this).children(".dropworn-arrow").stop(!0, !1).fadeToggle(150),
        a.preventDefault());
    }),
      a.on("click", function () {
        i.width() <= parseInt(979) &&
          (e(this).children(".js-nav-dropdown").fadeToggle(150),
          e(this).children(".dropworn-arrow").hide());
      }),
      t.on("click", function (i) {
        e(".navigation-menu > ul").toggleClass("show-on-mobile"),
          i.preventDefault();
      });
  });
})(jQuery);

/*##################### End Mega Menu ############################*/

$('.txt-slider').owlCarousel({
    center: true,
    loop:true,
    //center: true,
    margin:0,
    nav:false,
    dots:false,
    autoplay: true,
    slideTransition: 'linear',
    autoplayTimeout: 8000,
    autoplaySpeed: 25000,
    autoplayHoverPause: true,
    responsive:{
        0:{
            items: 1
        },
        610:{
            items:2
        },
        768:{
            items:2.5
        },
        991:{
            items: 3
        },
        1200:{
            items:3.2
        },
        1500:{
            items: 4.5        
        },
        1600:{
            items:4.5
        },
        1750:{
            items:5.5
        }
    }
});

/*####### Shop page js*/ 
$(document).ready(function () {
    $(".category_head .plusminus").click(function () {
        let head = $(this).parent(); // go up to .accordion_head
        let body = head.next(".category_nav_wrap"); // get its sibling body

        if (body.is(':visible')) {
            body.slideUp(300);
            $(this).text('+');
        } else {
            $(".category_nav_wrap").slideUp(300); // close all
            $(".plusminus").text('+');         // reset all plus
            body.slideDown(300);               // open this one
            $(this).text('-');                 // set minus
        }
    });

    // Auto expand when a sub-category is active
    let activeWrap = $(".sub-cat-active").closest('.category_nav_wrap');
    if (activeWrap.length) {
        activeWrap.addClass("active-parent").attr("style", "display:block;"); 
        activeWrap.prev(".category_head").find(".plusminus").text('-'); 
    }
});
